module.exports = __webpack_public_path__ + "static/media/wide-nre.89d13fd7.png";